import { useQuery } from "@tanstack/react-query";
import { fetchEngagementBlueprint } from "PFCore/services/admin/engagement_blueprints";
import { EngagementBlueprint, Id, QueryOptions } from "PFTypes";

import { engagementBlueprintsKeys } from "./query_keys";

export const useEngagementBlueprint = (id: Id, options: QueryOptions<EngagementBlueprint> = {}) =>
  useQuery<EngagementBlueprint>({
    queryKey: engagementBlueprintsKeys.single(id),
    queryFn: () => fetchEngagementBlueprint(id),
    ...options
  });
